import {
    SmallTextHelper
} from '../PrismicHelpers';

export const jobsPageHelper = (response) => {

    const jobsData = response.result;

    let jobsObject = jobsData.map(job => {
        return {
            uid: SmallTextHelper(job.id),
            job_title: SmallTextHelper(job.data.jobs_hero_title),
            job_summary: SmallTextHelper(job.data.job_summary),
            job_summary_label: SmallTextHelper(job.data.job_redirect_label),
            job_summary_path: SmallTextHelper(job.data.job_redirect_path),
            promo_title: SmallTextHelper(job.data.body[0].primary.promo_title),
            promo_summary: SmallTextHelper(job.data.body[0].primary.promo_summary),
            redirect_path: SmallTextHelper(job.data.body[0].primary.redirect_path),
            button_text: SmallTextHelper(job.data.body[0].primary.button_text)
        }
    })
    return jobsObject;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/JobsPageHelper.js